<template>
<div class="baner">
  <div class="baner-header">
    <div class="baner-header-top">
      <a href="/">
        <img src="@/assets/audi.png" alt="Audi" class="img-responsive">
      </a>
      <a href="/">
        <img src="@/assets/asp.png" alt="Audi Select Plus" class="img-responsive">
      </a>
    </div>
    <div class="baner-header-copy">
      <h1>Nie musi być nowe, aby spełnić Twoje marzenia.</h1>
      <p>
        Poznaj bogatą ofertę samochodów używanych Audi.
        <br>
        Sprawdzone. Pewne. Bezpieczne. 100% Audi.
      </p>
    </div>
  </div>
  <img src="@/assets/baner_lp.jpg" alt="">
</div>
</template>

<script>
export default {
  name: 'baner'
}
</script>

<style lang="scss" scoped>
.baner {
    line-height: 0;
    text-align: center;
    img {
        max-width: 100%;
        height: auto;
    }
    &-header {
      text-align: left;
        line-height: 1.25;
        position: absolute;
        top: 1rem;
        left: 0;
        right: 0;
        right: 0;
        width: 100%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 1rem;
      &-top{
        display: flex;
        justify-content: space-between;
        img {
            max-width: 35vw;
        }
      }
      &-copy{
        margin-top:5vh;
        h1{
          font-size: 2vw;
        }
        p{
          font-size: 1.8vw;
        }
      }
    }
}
</style>
